import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import {
  VIEW_DETAILS_COMMON_KEYS,
  VIEW_CHEQUE_BOOK_DETAILS_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function ChequeBookDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.ACCOUNT_NO)}</label>
        <span>{option?.accountNo || '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.BRANCH)}</label>
        <span>{option?.branchCode || '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.ADDRESS)}</label>
        <span>{option?.address || '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.NO_OF_CHEQUE_LEAVES)}</label>
        <span>{option?.noOfChequeLeaves || '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.NO_OF_CHEQUE_BOOK)}</label>
        <span>{option?.noOfChequeBooks || '-'}</span>
      </Col>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_CHEQUE_BOOK_DETAILS_KEYS.PICK_UP_BRANCH)}</label>
        <span>{option?.pickupBranch || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
